var map = {
	"./1INCH.png": 53201,
	"./3077.png": 39299,
	"./AAVE.png": 6051,
	"./ADA.png": 99099,
	"./ALGORAND.png": 79369,
	"./ATOM.png": 73798,
	"./AVALANCHE.png": 35318,
	"./AVAX.png": 93354,
	"./BCH.png": 8450,
	"./BINANCE.png": 72789,
	"./BINANCE_COIN.png": 25008,
	"./BINANCE_COIN_BSC.png": 91665,
	"./BITCOIN.png": 49107,
	"./BITCOIN_CASH.png": 33584,
	"./BNB.png": 7833,
	"./BTC.png": 23499,
	"./CAKE.png": 86406,
	"./CELO.png": 35230,
	"./CHAIN_LINK.png": 72127,
	"./CLASSIC_ETHEREUM.png": 15584,
	"./COMP.png": 82709,
	"./COMPOUND.png": 70154,
	"./COSMOS.png": 50663,
	"./CRO.png": 7989,
	"./DASH.png": 20412,
	"./DCR.png": 47924,
	"./DECRED.png": 2688,
	"./DODO.png": 87495,
	"./DOGE.png": 39104,
	"./DOGE_COIN.png": 54390,
	"./DOT.png": 1512,
	"./EGLD.png": 53915,
	"./ELROND.png": 77395,
	"./EOS.png": 75553,
	"./ETC.png": 22851,
	"./ETH.png": 6818,
	"./ETHEREUM.png": 85914,
	"./FANTOM.png": 10988,
	"./FIL.png": 94275,
	"./FILE_COIN.png": 27444,
	"./FLOW.png": 55096,
	"./FTM.png": 13412,
	"./FTT.png": 11532,
	"./FTX.png": 33035,
	"./GRT.png": 25533,
	"./HARMONY_ONE.png": 82965,
	"./HOLO.png": 6347,
	"./HOT.png": 26251,
	"./HT.png": 68159,
	"./LEO.png": 28893,
	"./LINK.png": 9392,
	"./LITE.png": 31752,
	"./LITE_COIN.png": 16533,
	"./LTC.png": 20591,
	"./LUNA.png": 73504,
	"./MATIC.png": 1175,
	"./MATIC1.png": 22463,
	"./MIOTA.png": 1308,
	"./MONERO.png": 35413,
	"./NEM.png": 34805,
	"./NEO.png": 77046,
	"./ONE.png": 47196,
	"./ONE_INCH.png": 16299,
	"./POLKADOT.png": 49059,
	"./QTUM.png": 15189,
	"./REEF.png": 54380,
	"./REEF_FINANCE.png": 82178,
	"./RIPPLE.png": 74351,
	"./SHIB.png": 70166,
	"./SHIBA_INU.png": 5805,
	"./SNX.png": 47961,
	"./SOL.png": 28523,
	"./SOLANA.png": 80334,
	"./STELLAR.png": 56800,
	"./SUSHI.png": 66954,
	"./SYNTHETIX.png": 2374,
	"./TERRA.png": 46215,
	"./TETHER.png": 26281,
	"./TEZOS.png": 87105,
	"./THE_GRAPH.png": 48128,
	"./TOMAN.png": 78903,
	"./TOMO.png": 23978,
	"./TOMO_CHAIN.png": 16910,
	"./TRON.png": 23546,
	"./TRX.png": 64697,
	"./UNI.png": 53047,
	"./UNI_SWAP.png": 38490,
	"./USDT.png": 1728,
	"./VECHAIN.png": 78731,
	"./VET.png": 21795,
	"./VE_CHAIN.png": 29804,
	"./WAVES.png": 35929,
	"./XEM.png": 84770,
	"./XLM.png": 83175,
	"./XMR.png": 80687,
	"./XRP.png": 54055,
	"./XTZ.png": 71929,
	"./ZEC.png": 51495,
	"./ZIL.png": 83548,
	"./ZILLIQA.png": 55633,
	"./Z_CASH.png": 98172
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6342;